import { useEffect, useState } from "react";
import Header from "../../../../../components/header";
import { shareURL } from "../../../../../utils/common";
import { useRabbitFestivalContext } from "../../hooks/festival-context";
import {
  FestivalCompetitionTab,
  RabbitFestivalPage,
} from "../../hooks/use-festival-tab";
import RabbitFestivalMainNewsList from "../main/components/news/list";
import RabbitFestivalCompetitionBanner from "./components/banner";
import RabbitFestivalCompetitionEvents from "./components/events";
import RabbitFestivalCompetitionPoster from "./components/poster";
import RabbitFestivalCompetitionTab from "./components/tab";
import {
  FestivalCompetitionWrapper,
  RabbitFestivalCompetitionNewsWrapper,
} from "./style";
import { getRFTNewsById, NewsResponse } from "../../../../../api/news";
import RabbitFestivalCompetitionSkeleton from "./skeleton";

const RabbitFestivalCompetition = () => {
  const {
    showHeader,
    setFestivalPage,
    setCompetitionId,
    setCompetition,
    competitionId,
    isCompetitionTab,
    competitionLoading,
  } = useRabbitFestivalContext();
  const [newsList, setNewsList] = useState<NewsResponse[]>([]);

  const handleShare = () => {
    if (!competitionId) return;
    shareURL(`${window.location.href}?competition=${competitionId}`);
  };

  const getNews = async () => {
    const res = await getRFTNewsById(competitionId);
    setNewsList(res);
  };

  useEffect(() => {
    getNews();
  }, []);

  if (competitionLoading) return <RabbitFestivalCompetitionSkeleton />;

  return (
    <FestivalCompetitionWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={showHeader}
        img={`/image-web/news/share${showHeader ? "_white" : ""}.svg`}
        back={() => {
          setFestivalPage(RabbitFestivalPage.MAIN);
          setCompetitionId(0);
          setCompetition(null);
        }}
        buttonClick={handleShare}
      />
      <RabbitFestivalCompetitionBanner />
      <RabbitFestivalCompetitionTab />
      {isCompetitionTab(FestivalCompetitionTab.EVENT) && (
        <RabbitFestivalCompetitionEvents />
      )}
      {isCompetitionTab(FestivalCompetitionTab.POSTER) && (
        <RabbitFestivalCompetitionPoster />
      )}
      {isCompetitionTab(FestivalCompetitionTab.NEWS) && (
        <RabbitFestivalCompetitionNewsWrapper>
          {newsList.length === 0 ? (
            <div className="no-data">뉴스가 존재하지 않습니다. </div>
          ) : (
            <RabbitFestivalMainNewsList
              newsList={newsList}
              loading={competitionLoading}
              search=""
            />
          )}
        </RabbitFestivalCompetitionNewsWrapper>
      )}
    </FestivalCompetitionWrapper>
  );
};

export default RabbitFestivalCompetition;
